// extracted by mini-css-extract-plugin
module.exports = {"mintYourPets":"MintYourPets_mintYourPets__-UZTC","title":"MintYourPets_title__3f2X5","stain":"MintYourPets_stain__2UgdX"};